export enum HeaderCellId {
	Student = 'Student',
	Class = 'Class',
	Group = 'Group',
	TestsTaken = 'Tests Taken',
	Credentials = 'Credentials',
}
